<template>
  <card-item :isFull="false" card="item_ticket" :tabs="tabs" v-model="activeTab" :id="id" />
</template>

<script>
export default {
  methods: {},
  props: ["id"],
  created() {
    try {
      if (this.$store.state.user.sections["tickets"]) {
        this.tabs.push({
          title: "Редактирование",
          key: "edit",
          component: () => import("./Edit"),
        });
      }
    } catch (error) {}
  },
  data() {
    return {
      tabs: [
        {
          title: "Информация",
          key: "information_card",
          component: () => import("./Info"),
        },
        {
          title: "Конференция",
          key: "conf",
          component: () => import("./Video"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>